export default "__VITE_ASSET__6c82abe4__"